<template>
  <vs-card>
    <div
      slot:header
      class="flex flex-no-wrap w-full justify-between items-center"
      vs-w="12"
    >
      <h4>Patients</h4>
      <div class="mr-2">
      </div>
    </div>
    <div>
      <div id="data-list-list-view" class="data-list-container">
        <div class="lg:hidden mt-3 patientlist-mobile">
          <div class="mb-2">
            <div class="w-full pr-1 flex flex-no-wrap">
              <vs-button v-if="showCTA" class="px-1" @click="createPatientDetailsDrawer=true" color="primary" >Create Patient</vs-button>
              <vs-input
                class="px-1"
                icon="search"
                style="width: 70%"
                placeholder="Search"
                v-model="searchInputString"
              />
              <vs-select
                class="px-1"
                width="30%"
                placeholder="10"
                autocomplete
                v-model="dataTableParams.limit"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in limitOptions"
                />
              </vs-select>

            <div class="export-container">
              <vs-button @click="exportPatientsList()">Export</vs-button>
            </div>
            </div>
            <div class="pr-1">
              <vs-select
                v-model="dataTableParams.clinicId"
                placeholder="All Clinic"
                autocomplete
                class="mr-6 p-1 w-full"
              >
                <vs-select-item
                  :key="index"
                  :value="item.clinicId"
                  :text="item.name"
                  v-for="(item, index) in clinics"
                />
              </vs-select>
            </div>
          </div>
          <ul>
          </ul>
        </div>
        <vs-table
          class="hidden lg:block patientlist-desktop"
          ref="table"
          :sst="true"
          :total="totalDocs"
          :data="users"
          @search="search"
          @change-page="handleChangePage"
          @sort="handleSort"
          :max-items="dataTableParams.limit"
          search
          :noDataText="noDataText"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse flex-grow justify-between"
          >
            <div class="flex flex-no-wrap items-center">
              <vs-select
                v-model="dataTableParams.clinicId"
                placeholder="All Clinic"
                autocomplete
                class="mr-6"
              >
                <vs-select-item
                  :key="index"
                  :value="item.clinicId"
                  :text="item.name"
                  v-for="(item, index) in clinics"
                />
              </vs-select>
              <vs-button v-if="showCTA" class="px-1" @click="createPatientDetailsDrawer=true" color="primary" >Create Patient</vs-button>
            </div>
            <div class="export-container">
              <vs-button @click="exportPatientsList()">Export</vs-button>
            </div>

          </div>

          <template slot="thead">
            <vs-th sort-key="clinicName">Full name</vs-th>
            <vs-th sort-key="clinicName">Email</vs-th>
            <vs-th sort-key="clinicName">Contact #</vs-th>
            <vs-th sort-key="address">Address</vs-th>
            <vs-th>Actions</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].fullName">{{
                data[indextr].fullName | capitalize
              }}</vs-td>
              <vs-td :data="data[indextr].email">{{
                data[indextr].email
              }}</vs-td>
              <vs-td :data="data[indextr].contactNumber">{{
                data[indextr].contactNumber | capitalize
              }}</vs-td>
              <vs-td :data="data[indextr].address">{{
                data[indextr].address | capitalize
              }}</vs-td>
              <vs-td :data="data[indextr]._id">
                <vs-button
                  style="float: left"
                  size="small"
                  type="border"
                  class="m-1"
                  @click="redirectToPatientEdit(data[indextr]._id)"
                >
                  View</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <ul class="block lg:hidden">
          <li :key="indextr" v-for="(tr, indextr) in users">
            <div
              class="rounded mb-2 p-2 mobile-text relative"
              style="border: 1px solid #e8e8e8"
              @click="redirectToPatientEdit(users[indextr]._id)"
            >
              <div>
                <h4 class="p-2 mobile-text">
                  {{
                    users[indextr].fullName
                      ? users[indextr].fullName
                      : "N/A" | capitalize
                  }}
                </h4>
              </div>
              <div v-if="users[indextr].email" class="p-2 mobile-text">
                <p>{{ users[indextr].email }}</p>
              </div>
              <div class="p-2 mobile-text">
                <p>{{ users[indextr].contactNumber }}</p>
              </div>
            </div>
          </li>
        </ul>
        <div
          class="
            m-2
            flex
            sm:justify-between
            justify-center
            items-center
            flex-wrap
          "
          style="height: 35px; padding-bottom: 30px"
        >
          <span class="mr-2">
            {{
              dataTableParams.page * dataTableParams.limit -
              (dataTableParams.limit - 1)
            }}
            -
            {{
              totalDocs - dataTableParams.page * dataTableParams.limit > 0
                ? dataTableParams.page * dataTableParams.limit
                : totalDocs
            }}
            of {{ totalDocs }}
          </span>
          <div class="pagination-div" v-if="serverResponded">
            <paginate
              :page-count="totalPage"
              :click-handler="handleChangePage"
              class="pagination"
              :page-range="5"
              :prevText="'<'"
              :nextText="'>'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
    <SideDrawerCreatePatient
      v-if="showCTA"
      :selectedClinic="dataTableParams.clinicId"
      :createPatientDetailsDrawer="createPatientDetailsDrawer"
      @closeSideDrawer="closeSideDrawer"
      @refetchPatientDetail="refetchPatientDetail"
    />
  </vs-card>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import SideDrawerCreatePatient from '@/views/general-component/treatment-history/SideDrawerCreatePatient.vue';

export default {
  name: 'organization-table',
  components: {
    SideDrawerCreatePatient,
  },
  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },
    viewRoute: {
      type: String,
      default: 'FranchiseNurseDetails',
    },
    viewDetailRoute: {
      type: String,
      default: 'OrgOwnerPatientDetail',
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    createRoute: {
      type: String,
      default: 'FranchiseNurseCreate',
    },
    canAssignClinic: {
      type: Boolean,
      default: true,
    },
    franchiseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      noDataText: 'Loading..',
      orgCount: 0,
      totalDocs: 0,
      currentPage: 1,
      searchInputString: null,
      dataTableParams: {
        search: '',
        sort: 'createdAt',
        dir: 'desc',
        page: 1,
        limit: 25,
        clinicId: null,
      },
      users: [],
      serverResponded: false,
      limitOptions: [5, 10, 25, 50, 100],
      clinics: [{ clinicId: null, name: 'All Clinics' }],
      awaitingSearch: null,
      createPatientDetailsDrawer: false,
    };
  },
  methods: {
    ...mapActions('orgOwner', ['getPatients', 'exportPatients']),
    ...mapActions('organization', ['fetchOrganizationAllClinics']),
    closeSideDrawer() {
      this.createPatientDetailsDrawer = false;
    },
    search(searching) {
      this.searchInputString = searching;
    },
    moment(date) {
      return moment(date);
    },
    refetchPatientDetail() {
      this.handleSearch('');
    },
    async getOrganizationPatientList() {
      this.$vs.loading();
      if (this.dataTableParams.status == 'all')
        this.dataTableParams.status = '';
      try {
        const res = await this.getPatients(this.dataTableParams);
        this.$vs.loading.close();
        this.users = res.data.data.docs;
        this.totalDocs = res.data.data.pagination.total;
        this.page = res.data.data.pagination.page;
        this.serverResponded = true;
        this.noDataText = 'No patients available';
      } catch (err) {
        console.log('This is the error ::', err);
      }
    },
    getOrganizationAllClinicsList() {
      this.fetchOrganizationAllClinics(this.dataTableParams.id).then((res) => {
        this.$vs.loading.close();
        this.clinics = [
          { clinicId: null, name: 'All Clinics' },
          ...res.data.data,
        ];
        this.noDataText = 'No Clinics Available';
      });
    },
    handleSearch(searching) {
      if (this.awaitingSearch) {
        clearTimeout(this.awaitingSearch);
        this.awaitingSearch = null;
      }
      this.awaitingSearch = setTimeout(() => {
        this.serverResponded = false;
        this.dataTableParams.search = searching;
        this.dataTableParams.page = 1;
        this.$refs.table.currentx = 1;
        this.getOrganizationPatientList();
      }, 500);
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      this.getOrganizationPatientList();
    },
    handleSort(key, active) {
      this.serverResponded = false;
      this.dataTableParams.sort = key;
      this.dataTableParams.dir = active;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.getOrganizationPatientList();
    },
    redirectToPatientEdit(id) {
      this.$router.push({
        name: this.viewDetailRoute,
        params: {
          patientId: id,
        },
      });
    },
    exportPatientsList() {
      this.$vs.loading();
      const payload = {
        org: [this.dataTableParams.id],
        clinic: this.dataTableParams.clinicId === null ? [] : [this.dataTableParams.clinicId],
      };
      this.exportPatients(payload).then((response)=> {
        const blob = new Blob([response.data], { type: 'text/csv' });

        const downloadUrl = window.URL.createObjectURL(blob);
        const downloadElement = document.createElement('a');
        downloadElement.href = downloadUrl;

        const contentDisposition = response.headers['content-disposition'];
        let filename = 'patients.csv';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/attachment; filename="?(.+)"?/);
            if (filenameMatch.length === 2) {
                filename = filenameMatch[1];
            }
        }

        downloadElement.setAttribute('download', filename);
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(downloadUrl);
        this.$vs.notify({
          title: 'Export Succesful',
          text: 'Patient Records have been downloaded to your device',
          color: 'success',
        });

        this.$vs.loading.close();
      }).catch((err) => {
          console.error('##ERROR: ', err);
          let errorMsg = 'Please try again, or contact support@freshclinics.com';
          if(err.status == 404) {
            errorMsg = 'No results found';
          }
          this.$vs.notify({
              title: 'Patient Export Unsuccesful',
              text: errorMsg,
              color: 'warning',
          });

        this.$vs.loading.close();
      });
    },
  },
  computed: {
    showCTA() {
      return JSON.parse(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)).doctorEMRClinics.length > 0;
    },
    totalPage: function () {
      return this.totalDocs / this.dataTableParams.limit >
        parseInt(this.totalDocs / this.dataTableParams.limit)
        ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
        : parseInt(this.totalDocs / this.dataTableParams.limit);
    },
  },
  watch: {
    nurseDetails: function (newVal) {
      this.handleSearch(newVal);
    },
    searchInputString: function (newVal) {
      this.handleSearch(newVal);
    },
    'dataTableParams.clinicId': function () {
      this.getOrganizationPatientList();
    },
    'dataTableParams.page': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.page = newVal;
      }
    },
    'dataTableParams.limit': function (newlimit, oldLimit) {
      if (newlimit !== oldLimit) {
        this.serverResponded = false;
        this.dataTableParams.page = 1;
        this.dataTableParams.limit = newlimit;
      }
    },
  },
  async created() {
    this.dataTableParams.id = localStorage.getItem(
      `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
    );
    this.getOrganizationAllClinicsList();
    this.getOrganizationPatientList();
  },
};
</script>
<style scoped>
.mobile-text {
  color: #164d3d;
}
</style>
<style>
.patientlist-desktop .export-container {
  position: absolute;
  right: 43px;
    margin-bottom: 3px;
}
.patientlist-desktop .vs-table--search {
  right: 80px;
}
.patientlist-mobile .export-container {
  margin-top: 2px;
}
</style>
